import * as yup from 'yup';
import { orgId, FieldValidation } from 'utils';
import { encode64 } from 'utils/ebUtils';

export default ({ addressValue, contactId, isExpectedLocation }) => {
  const locationValidation = new FieldValidation();
  return {
    locationName: yup
      .string()
      .trim()
      .required(`jquery.validation.field.required, ssp.address.locationname`)
      .when([], {
        is: () => isExpectedLocation !== true,
        then: yup.string().test('locationName', 'ssp.location.locationname.exist', (value) => {
          if ((!addressValue || value !== addressValue) && value && contactId) {
            return locationValidation.valid(value,
              `/${orgId}/${contactId}/addresses/validatelocname?locationName=${encode64(value)}&updateLocationName=`);
          }
          return true;
        }),
      }),
    arriveDate: yup
      .date()
      .when([], {
        is: () => isExpectedLocation === true,
        then: yup.date().required(`jquery.validation.field.required, ssp.address.start.date`),
      }),
    expireDate: yup
      .date()
      .when([], {
        is: () => isExpectedLocation === true,
        then: yup.date().required(`jquery.validation.field.required, ssp.address.end.date`),
      }),
    street: yup
      .string()
      .trim()
      .max(100, 'ssp.address.streetaddress.error')
      .required(`jquery.validation.field.required, ssp.address.streetaddress`),
    postalCode: yup
      .string()
      .test('postalCode', 'global.valid.text.postalCode', (value) => {
        if (value) {
          return /^[0-9A-Za-z- ]{3,10}$/.test(value);
        }
        return true;
      }),
    lat: yup
      .number()
      .max(90, 'ssp.address.latitude.error')
      .min(-90, 'ssp.address.latitude.error')
      .typeError('ssp.address.latitude.error'),

    lon: yup
      .number()
      .max(180, 'ssp.address.longitude.error')
      .min(-180, 'ssp.address.longitude.error')
      .typeError('ssp.address.longitude.error')
    ,
  };
};
